import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const ErrorIcon = (props: IIconProps) => {
  const {
    width = 24,
    height = 24,
    color = 'currentColor',
  } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.0049C16.9706 21.0049 21 16.9754 21 12.0049C21 7.03432 16.9706 3.00488 12 3.00488C7.02944 3.00488 3 7.03432 3 12.0049C3 16.9754 7.02944 21.0049 12 21.0049Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.63574 5.63965L18.367 18.3709"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(ErrorIcon);
